import horse from "./assets/horse.png"
import stars from "./assets/stars.png"
import border from "./assets/benefits-border.svg"
import benefits1 from "./assets/benefits-1.png"
import benefits2 from "./assets/benefits-2.png"
import benefits3 from "./assets/benefits-3.png"
import benefits4 from "./assets/benefits-4.png"
import benefits5 from "./assets/benefits-5.png"
import featured from "./assets/featured.png"
import usersLoveBg from "./assets/users-love-bg.svg"
import rating from "./assets/rating.png"
import pattern from "./assets/pattern-rectangles.png"
import devil from "./assets/devil.png"

const benefits = [
  {
    icon: benefits1,
    text: "Meet people who match your deepest tastes",
  },
  {
    icon: benefits2,
    text: "Make fantasies real, flirt freely",
  },
  {
    icon: benefits3,
    text: "Unlimited likes after signup",
  },
  {
    icon: benefits4,
    text: "Security, no screenshots",
  },
  {
    icon: benefits5,
    text: "Chat virtually via chat features on Pure",
  },
]

export function Benefits() {
  return (
    <div className="w-full relative text-white">
      <div className="w-full flex bg-violet-200 pr-6 pt-7 relative">
        <div
          className="relative z-[2] w-2/3 h-[317px] bg-right bg-[length:auto_100%] bg-no-repeat"
          style={{ backgroundImage: `url(${horse})` }}
        />
        <div className="w-1/3">
          <img
            src={stars}
            width={104}
            height={116}
            className="max-w-full h-auto mt-8"
          />
        </div>
        <img
          src={border}
          className="absolute bottom-0 right-0 w-full h-[208px] z-[1]"
        />
        <h2 className="w-[260px] absolute right-6 bottom-2 z-[3] font-quirk text-[32px] leading-[40px] tracking-[0.5px] -rotate-[4deg] px-2 text-right">
          What Pure opens up for you
        </h2>
      </div>
      <div className="bg-violet-190 pt-4 px-4 text-center pb-9">
        <div className="inline-block text-left -rotate-[2deg] mb-10">
          {benefits.map((benefit) => (
            <div
              className="flex items-center justify-start px-4 mb-2"
              key={benefit.text}
            >
              <img src={benefit.icon} className="w-5 h-5 mr-3" />
              <div className="text-sm tracking-[0.5px]">{benefit.text}</div>
            </div>
          ))}
        </div>
        <div
          className="mb-[52px] bg-no-repeat bg-[length:100%_100%] py-10 px-6 rotate-[2deg] max-w-[310px] mx-auto text-black"
          style={{ backgroundImage: `url(${usersLoveBg})` }}
        >
          <h2 className="font-quirk text-[32px] leading-[40px] tracking-[0.5px] rotate-[2deg] px-2 text-center mb-5">
            Featured in:
          </h2>
          <img
            src={featured}
            width={318}
            height={141}
            className="w-full h-auto max-w-[318px] mx-auto"
          />
        </div>
        <div
          className="bg-no-repeat bg-[length:100%_100%] pt-8 pb-7 px-4 max-w-[290px] mx-auto -rotate-[4deg] flex flex-col items-center text-black"
          style={{ backgroundImage: `url(${usersLoveBg})` }}
        >
          <h3 className="text-[18px] leading-[24px] tracking-[0.5px] font-sans-bold uppercase mb-4">
            Users love our plans
          </h3>
          <img
            src={rating}
            width={121}
            height={63}
            className="w-[121px] h-[63px]"
          />
          <div className="flex items-center mt-2">
            <div className="text-center mr-3">
              <div className="font-serif-bold font-bold text-[18px] leading-[22px]">
                64k
              </div>
              <div className="text-xs">reviews</div>
            </div>
            <div className="text-center mr-3">
              <div className="font-serif-bold font-bold text-[18px] leading-[22px]">
                72k
              </div>
              <div className="text-xs">5-star ratings</div>
            </div>
            <div className="text-center mr-3">
              <div className="font-serif-bold font-bold text-[18px] leading-[22px]">
                10m
              </div>
              <div className="text-xs">downloads</div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="bg-violet-190 bg-[length:100%_auto] bg-no-repeat bg-center"
        style={{ backgroundImage: `url(${pattern})` }}
      >
        <div className="flex">
          <h2 className="self-end w-1/2 pl-8 font-quirk text-[32px] leading-[40px] tracking-[0.5px] -rotate-[4deg] text-left mb-5 whitespace-nowrap">
            Girls are
            <br />
            waiting for
            <br />
            your next step
          </h2>
          <div
            className="bg-no-repeat bg-left bg-[length:auto_100%] w-1/2 h-[265px]"
            style={{ backgroundImage: `url(${devil})` }}
          />
        </div>
      </div>
      <div className="bg-violet-190 px-8 pb-8">
        <p className="text-[14px] leading-[25px] tracking-[0.5px] rotate-[1deg] max-w-[250px]">
          Pure is a place to explore your sexuality in a playful, safe and
          honest way.
        </p>
      </div>
    </div>
  )
}
